//import React from 'react';


export const html = (value) => String(value || '').replace(/[^ \wА-Яа-яЁё,?!:;%$#@={}*/|\.\-\+\[\]\(\)]/gim, (chr) => '&#' + chr.charCodeAt(0) + ';');

export const regexp = (value) => String(value || '').replace(/[\\'"\[\]\(\)\{\}\*\?\+\-\.\^\$\n\r]/g, (chr) => chr === '\n' ? ('\\n') : chr === '\r' ? ('\\r') : ('\\' + chr));
